import { success } from 'redux-saga-requests';

import { ReducerUtil } from 'doctivity-shared/utils';
import { TagsUtil } from 'utils';

import {
  API_TAG_NAMESPACES_LIST_BY_CLIENT,
  API_TAG_NAMESPACES_LOAD,
  API_TAG_NAMESPACES_LIST,
  API_TAG_NAMESPACES_TABLE,
  API_TAG_NAMESPACES_UPSERT,
  API_TAG_NAMESPACES_PROVIDERS_LIST,
} from 'store/actions/tagNamespacesActions';

export const tagNamespaces = (state = {}, action = null) => {
  let result = ReducerUtil.simpleReduce(
    state,
    action,
    API_TAG_NAMESPACES_TABLE,
    API_TAG_NAMESPACES_LIST,
    API_TAG_NAMESPACES_UPSERT,
  );
  if (result.actionConsumed) {
    if (success(API_TAG_NAMESPACES_UPSERT)) {
      result.state[API_TAG_NAMESPACES_LIST_BY_CLIENT] = null;
    }
    return result.state;
  }

  result = ReducerUtil.reduceListGet(
    state,
    action,
    API_TAG_NAMESPACES_LIST_BY_CLIENT,
    API_TAG_NAMESPACES_LIST_BY_CLIENT,
  );
  if (result.actionConsumed) {
    if (action.clientId) {
      result.state[API_TAG_NAMESPACES_LIST_BY_CLIENT].clientId = action.clientId;
    } else if (action.meta && action.meta.requestAction.clientId) {
      result.state[API_TAG_NAMESPACES_LIST_BY_CLIENT].clientId = action.meta.requestAction.clientId;
    }
    if (success(API_TAG_NAMESPACES_LIST_BY_CLIENT)) {
      TagsUtil.indexTags(result.state[API_TAG_NAMESPACES_LIST_BY_CLIENT]);
    }
    return result.state;
  }

  // Provider tag namespaces — used by AI Provider Filter
  result = ReducerUtil.reduceListGet(
    state,
    action,
    API_TAG_NAMESPACES_PROVIDERS_LIST,
    API_TAG_NAMESPACES_PROVIDERS_LIST,
  );
  if (result.actionConsumed) {
    if (result.state[API_TAG_NAMESPACES_PROVIDERS_LIST]) {
      if (action.clientId) {
        result.state[API_TAG_NAMESPACES_PROVIDERS_LIST].clientId = action.clientId;
      } else if (action.meta && action.meta.requestAction.clientId) {
        result.state[API_TAG_NAMESPACES_PROVIDERS_LIST].clientId = action.meta.requestAction.clientId;
      }
    }
    return result.state;
  }

  result = ReducerUtil.reduceSingleGet(state, action, API_TAG_NAMESPACES_LOAD);
  if (result.actionConsumed) {
    return result.state;
  }

  return state;
};